import script from "./AdminShell.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminShell.vue?vue&type=script&setup=true&lang=js"

import "./AdminShell.vue?vue&type=style&index=0&id=154ceacd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154ceacd"]])

export default __exports__